import { useState } from "react";
import "../Authentication.css";
import "./Login.css";
import { Link } from "react-router-dom";
import {
  FORGOT_PASSWORD_PATH,
  REGISTER_PATH,
} from "../../../constants";
import { FIREBASE_AUTH } from "../../../FirebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import InputField from "../InputField";

const Login = () => {
  const [theEmail, setTheEmail] = useState("");
  const [thePassword, setThePassword] = useState("");
  const [loading, setLoading] = useState(false);
  const auth = FIREBASE_AUTH;
  const navigate = useNavigate();

  const signIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await signInWithEmailAndPassword(
        auth,
        theEmail,
        thePassword
      );
    } catch (error) {
      alert("login failed " + error.message);
    } finally {
      setLoading(false);
      navigate("/");
    }
  };

  return (
    <div className="auth-main-container">
      <div className="auth-white-box">

        <form className="auth-form" onSubmit={signIn}>
            <h1>LOGIN</h1>

            <InputField
              label="EMAIL"
              name="email"
              value={theEmail}
              type="email"
              placeholder="fakeEmail@gatech.edu"
              onChange={setTheEmail}
            />

            <InputField
              label="PASSWORD"
              name="password"
              value={thePassword}
              type="password"
              placeholder="Password"
              onChange={setThePassword}
            />

            <div className="login-forgot-password-container ">
              <input
                className="auth-button"
                type="submit"
                value="Login"
                disabled={loading}
              />

              <Link to={FORGOT_PASSWORD_PATH} className="forgot-password-link">
                Forgot Password?
              </Link>
            </div>
            

            <div className="register-container">
              <span className="login-register-text">Don't have an account?</span>
              <Link to={REGISTER_PATH} className="register-link">
                Register
              </Link>
            </div>
        </form>

      </div>
    </div>
  );
};

export default Login;
